
export default {
    getFieldMap(configList){
        var returnObj = new Object();
        for(var i=0; i < configList.length; i++){
            var obj = configList[i];
            var keys = Object.keys(obj);
            keys.forEach(function(key){
                returnObj[key] = obj[key];
            });
        }
        return returnObj;
    },
    getNewFieldName(fieldMap, key) {
        if (fieldMap.hasOwnProperty(key)) {
            return fieldMap[key];
        }
        return null;
    },
    showProps(obj, parentName, fieldMap, newObj) {	
        var keys = Object.keys(obj);
        for (var k=0; k < keys.length; k++) {
            var name = keys[k];

            var fieldPath = name;
            if (parentName != "") {
                fieldPath = parentName + "_" + name;
            }
            
            var newFieldName = this.getNewFieldName(fieldMap, fieldPath);
            if (newFieldName == null) {
                newFieldName = name;
            }

            var currentObj = obj[name];
            if (currentObj) {
                if(Array.isArray(currentObj)) {
                    newObj[newFieldName] = new Array();
                    for(var i=0; i < currentObj.length; i++) {
                        newObj[newFieldName].push(new Object());
                        this.showProps(currentObj[i], fieldPath, fieldMap, newObj[newFieldName][i]);
                    }
                } else if (typeof(currentObj) == "object") {
                    newObj[newFieldName] = new Object();
                    this.showProps(currentObj, fieldPath, fieldMap, newObj[newFieldName]);
                } else {
                    newObj[newFieldName] = currentObj;
                }
            } else {
                newObj[newFieldName] = currentObj;
            }
        }
        return newObj
    },
    nodeSplicing(nodeParams,configList,simpleMap){
        let vm = this
        let params = nodeParams.node
        let item = nodeParams.param
        let breadcrumb = nodeParams.breadcrumb
        let nodeArr = []
        if(params.indexOf(",") > -1){
            nodeArr = params.split(",")
        }else {
            nodeArr.push(params)
        }
        let nodeStr = ''
        let oldNodeStr = ''
        for(let i=0;i<nodeArr.length;i++){
            if(i == 0){
                nodeStr+=nodeArr[i]
                oldNodeStr+=configList[nodeStr].apiFiled
            }else if(i > 0 && i < (nodeArr.length - 1)){
                nodeStr+='_'+nodeArr[i]
                oldNodeStr+=configList[nodeStr].apiFiled
            }else{
                nodeStr+='_'+nodeArr[i]
            }
        }
        let nodeObj = configList[nodeStr]
        
        let linkParam = []
        if(nodeObj.linkParam.indexOf(",") > -1){
            linkParam = nodeObj.linkParam.split(',')
        }else{
            linkParam.push(nodeObj.linkParam)
        }
        let irouterParams = new Object()
        for(let j=0;j<linkParam.length;j++){
            let key = linkParam[j]
            if(key != ''){
                let paramsVal = simpleMap[oldNodeStr+'_'+key]
                irouterParams[key] =  item[paramsVal]
            }
        }
        
        let stemp
        if(nodeObj.clickEvent == 1){
            if(nodeObj.clickFunc == 1){//页面跳转
                if(breadcrumb){
                    irouterParams.breadcrumb =[{name: breadcrumb, component: nodeObj.linkSrc}]
                }
                if(nodeParams.otherParam){
                    let other = nodeParams.otherParam
                    for(i in other){
                        irouterParams[i] = other[i]
                    }
                }
                stemp = {
                    name:nodeObj.linkSrc, //跳转地址
                    param:irouterParams //参数字段
                }
                return stemp
            }
            else{//下载
                http.get(InterfacePrefix['resource'] + '/common/operate/'+irouterParams.id+"/2").then(function (xhr) {
                    if (xhr.data.code) return // 异常情况有公共处理
                    vm.downImpl(irouterParams);
                });
            }
        }
    },
    downImpl(irouterParams){
        if (irouterParams.typeCode=='0' || irouterParams.typeCode=='8' ){
            //批量下载
            window.filesystemDownload([{ids:irouterParams.downLoadIds},{filename:irouterParams.title}])
        }else {
            //单文件下载
            let downloadUrl = window.systemParameter.FILE_SYSTEM_URL + "/file/download/" //单个资源下载地址
            location.href= downloadUrl +irouterParams.fileId;
        }
    },
    routerParams(){

    }
}


// WEBPACK FOOTER //
// ./src/components/homepage/widget/widgetFilter.js